"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Dialog as DialogPrimitive } from "radix-ui";
import { cn } from "@/lib/utils/cn";
const Dialog = DialogPrimitive.Root;
const DialogTrigger = DialogPrimitive.Trigger;
const DialogPortal = DialogPrimitive.Portal;
const DialogClose = DialogPrimitive.Close;
const fadeAnimation = "duration-200 ease-out fade-in-0 fade-out-0 data-[state=open]:animate-in data-[state=closed]:animate-out";
const scaleAnimation = "motion-safe:zoom-in-95 motion-safe:zoom-out-95";
function DialogOverlay(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn("fixed inset-0 z-100 bg-black/90", fadeAnimation, className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <DialogPrimitive.Overlay data-slot="dialog-overlay" className={t2} {...props} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
interface DialogContentProps extends React.ComponentProps<typeof DialogPrimitive.Content> {
  overlayClassName?: string;
}
function DialogContent(t0) {
  const $ = _c(16);
  let children;
  let overlayClassName;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      overlayClassName,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = overlayClassName;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    overlayClassName = $[2];
    props = $[3];
    t1 = $[4];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[5] !== overlayClassName) {
    t2 = <DialogOverlay className={overlayClassName} />;
    $[5] = overlayClassName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== className) {
    t3 = cn("fixed inset-0 z-100", fadeAnimation, scaleAnimation, className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== t3) {
    t4 = <DialogPrimitive.Content data-slot="dialog-content" className={t3} {...props}>{children}</DialogPrimitive.Content>;
    $[9] = children;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <DialogPortal>{t2}{t4}</DialogPortal>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function DialogTitle(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[3] !== className || $[4] !== props) {
    t2 = <DialogPrimitive.Title data-slot="dialog-title" className={className} {...props} />;
    $[3] = className;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function DialogDescription(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[3] !== className || $[4] !== props) {
    t2 = <DialogPrimitive.Description data-slot="dialog-description" className={className} {...props} />;
    $[3] = className;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export { Dialog, DialogTrigger, DialogPortal, DialogClose, DialogOverlay, DialogContent, DialogTitle, DialogDescription };